import React from 'react';
import Layout from '../components/layout/Layout';
import QRCodeScanner from '../components/qrcode/QRCodeScanner';

const ScanQR = () => {

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="bg-blue-600 px-6 py-4">
            <h1 className="text-2xl font-bold text-white">Scan QR Code</h1>
            <p className="text-blue-100">
              Scan a lab item QR code to check in/out or view details
            </p>
          </div>
          
          <div className="p-6">
            <QRCodeScanner />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ScanQR;
